import './styles/global.css';
import './translations/index';
import Routes from './routes/Routes';

function App() {
  return <Routes />;
}

export default App;
